
import request from "../utils/request";


export function cmsBannerList(data) {
    return request({
        url: "/banner/cmsBannerList",
        data: data,
    });
}

export function addBanner(data) {
    return request({
        url: "/banner/addBanner",
        data: data,
    });
}

export function delBanner(data) {
    return request({
        url: "/banner/delBanner",
        data: data,
    });
}